<template>
  <div class="layout-segment">
    <a-row>
      <a-col :sm="24" :md="17">
        <div class="rodo-clause font-14">
          <p>
	  	<div> DEBUG:
		'transactionId': '{{ transactionId }}',<br/>
                'transactionAffiliation': '',<br/>
		'transactionTotal': {{ gaPrice }},<br/>
		'transactionAddInfo': '{{ uwagi }}',<br/>
                'transactionShipping': 0,<br/>
                'transactionTax': 0,<br/>
                'transactionProducts':<br/>
			'name': '{{ prodNameFull }}',<br/>
			'sku': {{ sku }},<br/>
			'category': '{{ prodCategory }}',<br/>
			'price': {{ gaPrice }},<br/>
                        'quantity': 1<br/>

                </div>
                <div style="clear:both;">
                        <button @click="debugInfoT">Click me for Transaction Details</button>
                </div>
          </p>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>

import * as CONFIG from "./config.js";

export default {
  data: () => ({
    gtm_id: "",
    transactionId: "",
    transactionAffiliation: "",
    cenawyc: "",
    transactionShipping: "",
    transactionTax: "",
    prodName: "",
    terminwyc: "",
    prodCategory: "",
    uwagi: "",
    gaPrice: "", 
    gaPriceX: "",
    prodNameFull: "",
    sku: "",
  }),
  methods: {
	parseTxParams() {
		this.gtm_id = this.paramValue("id");
		this.transactionId = this.paramValue("transactionId");
		this.transactionAffiliation = this.paramValue("transactionAffiliation");
		this.cenawyc = this.paramValue("cenawyc");
		this.transactionShipping = this.paramValue("transactionShipping");
		this.transactionTax = this.paramValue("transactionTax");
		this.prodName = this.paramValue("prodName");
		this.terminwyc = this.paramValue("terminwyc");
		this.prodCategory = this.paramValue("prodCategory");
		this.uwagi = this.paramValue("uwagi");
	},
	paramValue(par) {
		let param = this.$route.query;
      		if (param[par]) {
			return decodeURIComponent(param[par]);
		} else {
			return "";
		}
	},
	calculatePrice() {
		if (this.cenawyc !== "" && this.cenawyc.indexOf("nieznana") == -1 && this.cenawyc.indexOf("z") != -1) {
			this.gaPriceX = this.cenawyc.substring(0, this.cenawyc.indexOf("z"));
		} else if (this.cenawyc !== "" && this.cenawyc.indexOf("nieznana") == -1 && this.cenawyc.indexOf("PLN")) {
			this.gaPriceX = this.cenawyc.substring(0, this.cenawyc.indexOf("PLN"));
		} else if (this.cenawyc !== "" && this.cenawyc.indexOf("nieznana") == -1 && this.cenawyc.indexOf("EUR")) {
			this.gaPriceX = this.cenawyc.substring(0, this.cenawyc.indexOf("EUR"));
		} else if (this.cenawyc !== "" && this.cenawyc.indexOf("nieznana") == -1 && this.cenawyc.indexOf("USD")) {
			this.gaPriceX = this.cenawyc.substring(0, this.cenawyc.indexOf("USD"));
		} else {
			this.gaPriceX = this.cenawyc;
		}
	},
	calculateFinalPrice() {
		var newprice = this.gaPriceX.replaceAll(' ','');
		this.gaPrice = newprice.replaceAll(',','.');
	},
	fillDomain() {
		this.prodNameFull = CONFIG.panstwo_nazwapl;

		var tripDate = Date.parse(this.terminwyc, 'Y-m-d');
                var todayDate = new Date().getTime();
                var diffDate = tripDate - todayDate;

                var numMonths = (diffDate)/2628000000;
                var numDays = (diffDate)/86400000;

                var sku = '';
		if (numMonths >= 1 && numMonths < 2) {
                	sku = '1-2 m-ce';
                } else if (numDays <= 10) {
                	sku = '<=10 dni';
		}else if (numDays >=11 && numDays <= 21) {
                	sku = '11-21 dni';
		}else if (numDays >=22 && numDays <= 30) {
                	sku = '22-30 dni';
                } else {
			sku = '>2 m-cy';
                }
		this.sku = sku;

                dataLayer.push({
                'transactionId': "'" + this.transactionId + "'",
                'transactionAffiliation': '',
                'transactionTotal': this.gaPrice,
                'transactionAddInfo': "'" + this.uwagi + "'",
                'transactionShipping': 0,
                'transactionTax': 0,
                'transactionProducts': [{
                        'name': "'" + this.prodNameFull + "'",
                        'sku': sku,
                        'category': "'" + this.prodCategory + "'",
                        'price': this.gaPrice,
                        'quantity': 1
                }]

                });

	},
	debugInfoT() {
                        var dl = {
                'transactionId': "'" + this.transactionId + "'",
                'transactionAffiliation': '',
                'transactionTotal': this.gaPrice,
                'transactionAddInfo': "'" + this.uwagi + "'",
                'transactionShipping': 0,
                'transactionTax': 0,
                'transactionProducts': [{
                        'name': "'" + this.prodNameFull + "'",
                        'sku': "'" + this.sku + "'",
                        'category': "'" + this.prodCategory + "'",
                        'price': this.gaPrice,
                        'quantity': 1
                }]

                        }
                alert("dataL=" + JSON.stringify(dl));
        }
  },
  mounted() {
	this.parseTxParams();
	if (this.gtm_id !== "") {
		console.log("Found transaction params. Will proceed with saving the Tx...");
 		this.calculatePrice();
		this.calculateFinalPrice();
		this.fillDomain();
		console.log("Tx saved.");
	} else {
		console.log("Error: No transaction params found.");
	}
  }
};

</script>

<style lang="scss" scoped>
@import "@/scss/_components/_T1RODO";
</style>
